module.exports = __webpack_public_path__ + "static/img/logo-nutraceutical.bcb536ba.svg";